<script lang="ts">
	export let text = ''
	export let position: 'left' | 'right' | 'bottom' | 'top' = 'bottom'
	export let displayArrow = true
	// export let backcolor = "black"
	export let backcolor = '#474747'

	let className = ''
	export { className as class }
	export let classWrapper = 'w-full'

	let visible = false
	let calculated = false
	let nodeWidth = 0
	let nodeHeight = 0
	let tooltipWidth = 0
	let tooltipHeight = 0

	let translateX = 0
	let translateY = 0
	let translateArrowX = 0
	let translateArrowY = 0

	let points = '0,0 0,0 0,0'

	const mouseOver = (event: MouseEvent) => {
		if (text === '') return
		if (calculated) return

		calculate()

		visible = true
	}

	const mouseMove = (event: MouseEvent) => {
		if (text === '') return
		if (calculated) return

		calculate()
		calculated = true
	}

	const calculate = () => {
		if (position === 'right') calculateRight()
		else if (position === 'top') calculateTop()
		else if (position === 'left') calculateLeft()
		else calculateBottom()
	}

	const calculateBottom = () => {
		translateX = Math.round((nodeWidth - tooltipWidth) / 2)
		translateY = 0
		translateArrowX = -12
		translateArrowY = -12
		points = '0,127.5 255,127.5 127.5,0'
	}

	const calculateTop = () => {
		translateX = Math.round((nodeWidth - tooltipWidth) / 2)
		// translateY = - nodeHeight - tooltipHeight - 10
		translateY = -nodeHeight - tooltipHeight - 8
		translateArrowX = -12
		// // translateArrowY = tooltipHeight - 7
		translateArrowY = tooltipHeight - 8
		points = '0,0 127.5,127.5 255,0'
	}

	const calculateLeft = () => {
		translateX = -tooltipWidth - 3
		translateY = -Math.round(nodeHeight / 2) - Math.round(tooltipHeight / 2) - 6
		translateArrowX = Math.round(tooltipWidth - tooltipWidth / 2) - 10
		translateArrowY = Math.round(tooltipHeight / 2) - 12
		points = '0,0 127.5,127.5 0, 255'
	}

	const calculateRight = () => {
		translateX = nodeWidth + 3
		translateY = -Math.round(nodeHeight / 2) - Math.round(tooltipHeight / 2) - 6
		translateArrowX = -Math.round(tooltipWidth / 2) - 10
		translateArrowY = Math.round(tooltipHeight / 2) - 12
		points = '0,127.5 127.5,0 127.5,255'
	}

	const close = () => {
		visible = false
		calculated = false
	}
</script>

{#if text == ''}
	<div class="relative {classWrapper} flex items-center">
		<slot />
	</div>
{:else}
	<!-- svelte-ignore a11y-mouse-events-have-key-events -->
	<!-- svelte-ignore a11y-click-events-have-key-events-->
	<div class="relative {classWrapper} flex items-center"
		on:mouseover={(e) => mouseOver(e)}
		on:mouseleave={() => close()}
		on:mousemove={(e) => mouseMove(e)}
		on:click={() => close()}
		bind:clientWidth={nodeWidth}
		bind:clientHeight={nodeHeight}
	>
		<slot />
	</div>

	{#if visible}
		<div
			class="absolute {className} opacity-100 z-50 text-white text-center text-xs rounded-lg my-1 py-2 px-3 pointer-events-none"
			bind:clientWidth={tooltipWidth}
			bind:clientHeight={tooltipHeight}
			style="transform: translate({translateX}px, {translateY}px); background-color: {backcolor}; border-color: {backcolor}"
		>
			{#if displayArrow}
				<svg
					class="absolute z-50 h-2 w-full"
					x="0px"
					y="0px"
					viewBox="0 0 255 255"
					xml:space="preserve"
					style="transform: translate({translateArrowX}px, {translateArrowY}px); color: {backcolor}"
				>
					<polygon class="fill-current" {points} />
				</svg>
			{/if}
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html text}
		</div>
	{/if}
{/if}
